import ButtonTooltip from "components/Common/ButtonTooltip"
import CustomerAddEdit from "pages/CustomerPages/Customer/CustomerAddEdit"
import { useState } from "react"

const ProfileEdit = ({ data, onCustomer }) => {
  const [modal, setModal] = useState(false)

  const toggleModal = () => setModal(prev => !prev)

  return (
    <>
      <ButtonTooltip
        type="edit"
        onClick={toggleModal}
        btnId={`customer-profile-edit-${data?.id || data?.cuid || "new"}`}
        btnName="Edit Profile"
      />

      <CustomerAddEdit
        modal={modal}
        toggleModal={toggleModal}
        isEdit={Boolean(data?.id)}
        editedData={data}
        onSuccess={onCustomer}
      />
    </>
  )
}

export default ProfileEdit
